module.exports = require("es-toolkit/object");